import React, { useState, useEffect } from 'react';
import { Radio, Menu, X, Facebook, Twitter, Instagram, Youtube, LayoutDashboard } from 'lucide-react';
import logo from '../assest/images/ZMURADIO LOGO 1600x800.png';

/**
 * مكون الهيدر - نمط الجامعة العسكرية
 */
const NewHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect for border
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { nameAr: 'البث المباشر ', icon: Radio, href: '#live' }
  ];

  // eslint-disable-next-line no-unused-vars
  const socialLinks = [
    { icon: Facebook, href: '#', label: 'فيسبوك', color: 'hover:text-blue-600' },
    { icon: Twitter, href: '#', label: 'تويتر', color: 'hover:text-blue-400' },
    { icon: Instagram, href: '#', label: 'انستغرام', color: 'hover:text-pink-600' },
    { icon: Youtube, href: '#', label: 'يوتيوب', color: 'hover:text-red-600' },
  ];

  // Handle smooth scroll to section
  const handleNavClick = (e, href) => {
    e.preventDefault();
    const targetId = href.replace('#', '');
    
    // Dashboard navigation via hash change
    if (targetId === 'dashboard') {
      window.location.hash = 'dashboard';
      setIsMenuOpen(false);
      return;
    }

    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      
      // Close mobile menu if open
      setIsMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'border-b-2 border-gold shadow-lg' : ''
      }`}
      // style={{ backgroundColor: isScrolled ? '#D3CEC8' : 'transparent' }}
      style={{ backgroundColor: '#D3CEC8' }}
      dir="rtl"
    >
      <nav className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          
          {/* Right Side: University Logo + Navigation */}
          <div className="flex items-center gap-6">
            {/* University Logo */}
            <div className="flex items-center gap-2">
              <img 
                src={require('../assest/images/ZMU Logo_page-0001-Photoroom.png')} 
                alt="جامعة زايد" 
                className="w-36 h-18 md:w-40 md:h-20"
              />
            </div>

            {/* Navigation Items - Desktop */}
            <nav className="hidden lg:flex items-center gap-2">
              {navItems.map((item) => (
                <a
                  key={item.nameAr}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="group flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 cursor-pointer text-gold hover:bg-white/30 hover:text-gold-dark"
                >
                  <item.icon className="w-5 h-5" />
                  <span className="font-bold text-sm">{item.nameAr}</span>
                </a>
              ))}
            </nav>
          </div>

          {/* Left Side: Main Logo + Social Media + App Download */}
          <div className="flex items-center gap-4">
            {/* Social Media Links - Desktop */}
            {/* <div className="hidden md:flex items-center gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className={`p-2 rounded-full border-2 border-transparent transition-all duration-300 text-gray-600 ${social.color} hover:border-gold hover:bg-white/20`}
                  aria-label={social.label}
                >
                  <social.icon className="w-6 h-6" />
                </a>
              ))}
            </div> */}

            {/* App Store Icons */}
            {/* <div className="hidden md:flex items-center gap-2"> */}
              {/* Google Play */}
              {/* <a
                href="#google-play"
                className="p-2 rounded-lg border-2 border-transparent transition-all duration-300 hover:border-gold hover:bg-white/20"
                aria-label="حمّل من Google Play"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                </svg>
              </a> */}
              
              {/* App Store */}
              {/* <a
                href="#app-store"
                className="p-2 rounded-lg border-2 border-transparent transition-all duration-300 hover:border-gold hover:bg-white/20"
                aria-label="حمّل من App Store"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                </svg>
              </a>
            </div> */}

            {/* Main Logo */}
            <div className="flex items-center gap-2">
              <img 
                src={logo} 
                alt="إذاعة جامعة زايد" 
                className="w-36 h-18 md:w-40 md:h-20"
              />
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-lg transition-colors text-gray-800 hover:bg-white/30"
              aria-label="القائمة"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 animate-fade-in bg-white/95 backdrop-blur-md rounded-xl p-4 shadow-xl">
            <div className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <a
                  key={item.nameAr}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="flex items-center gap-3 text-gold hover:text-gold-dark hover:bg-gold/10 p-3 rounded-lg transition-all duration-300 border border-transparent hover:border-gold/30 cursor-pointer"
                >
                  <item.icon className="w-5 h-5 text-gold" />
                {/*   <span className="font-bold">{item.nameAr}</span> */}
                </a>
              ))}
              
              {/* Social Media - Mobile */}
              {/* <div className="flex items-center justify-center gap-3 pt-3 border-t border-gray-200">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className={`p-2 rounded-full ${social.color} bg-gray-100 hover:bg-gray-200 transition-all`}
                    aria-label={social.label}
                  >
                    <social.icon className="w-6 h-6" />
                  </a>
                ))}
              </div> */}

              {/* App Store Icons - Mobile */}
              {/* <div className="flex items-center justify-center gap-4 pt-3 border-t border-gray-200 mt-2"> */}
                {/* Google Play */}
                {/* <a
                  href="#google-play"
                  className="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-300 hover:scale-110"
                  aria-label="حمّل من Google Play"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
                  </svg>
                </a> */}
                
                {/* App Store */}
                {/* <a
                  href="#app-store"
                  className="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-300 hover:scale-110"
                  aria-label="حمّل من App Store"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                  </svg>
                </a> */}
              {/* </div> */}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default NewHeader;
